<template>
    <div class="of-content5-topper">
        <div class="topper-content">
            <h2 class="topper-content-title" v-html="topper.title" ></h2>
            <h4 class="topper-content-text" v-html="topper.text" ></h4>
        </div>
        <div class="topper-main-svg">
            <img :src="topper.mainSvg" alt="" srcset="">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'topper',
        props: ["view"],
        data(){
            return {
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-topper.svg',
                title: 'TRAINING BUILDERALL',
                text: 'We Provide Every Other Tool You Will Ever Need To Explode Your Business Online!'
            }
        },
        computed: {
            topper: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created(){},
        mounted(){}
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";
    .of-content5-topper {
        font: inherit;
        border-radius: 4px;
        background-color: $of-color3;

        display: grid;
        grid-template-columns: repeat(10, 1fr);
        grid-template-rows: auto;
        justify-items: stretch;
        align-items: stretch;
        justify-content: start;
        align-content: stretch;
        
        .topper-content {
            font: inherit;
            text-align: left;
            position: relative;
            background-color: $of-color1;
            padding: 6.2em 4em 6.2em 3.2em; /* 62px, 32px, 62px, 32px */

            clip-path: polygon(0 0, 100% 0, 90% 100%, 0% 100%);

            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 5;

            h2,
            .topper-content-title {
                font: inherit;
                font-family: $of-font1;
                font-size: 5.6em; /* 56px */
                font-weight: 700;
                color: $of-color3;
                line-height: 1.2;

                margin: 0 0 0.535714286em 0; /* 30px */       
                max-width: 85%;
            }
            h4,
            .topper-content-text {
                font: inherit;
                font-size: 2.0em; /* 20px */
                font-weight: 900;
                color: $of-color3;
                line-height: 1.2;
                margin: 0;
                max-width: 85%;
            }
        }
        .topper-main-svg {
            font: inherit;
            padding: 9.6em 2.7em 5em 1.2em; /* 96px 27px 50px 12px */

            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 5;
            grid-column-end: 11;

            img {
                width: 100%;
                height: auto;
                max-height: 100%;
            }
        }
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content5-topper{
            grid-template-columns: 1fr;
            grid-template-rows: repeat(2, auto);
            align-items: start;
            justify-items: center;

            .topper-main-svg{
                width: 100%;
                grid-row-start: 2;
                grid-row-end: 3;
                grid-column-start: 1;
                grid-column-end: 2;
                
                padding: 5%;

                img {
                    width: 90%;
                    height: auto;
                    max-height: 100%;
                }
            }
            .topper-content{
                width: 100%;
                padding: 10% 5% 15% 5%;

                grid-row-start: 1;
                grid-row-end: 2;
                grid-column-start: 1;
                grid-column-end: 2;

                clip-path: polygon(0 0, 100% 0, 100% 90%, 0% 100%);

                text-align: center;

                .topper-content-title,
                .topper-content-text{
                    max-width: 100%;
                    word-break: break-word;
                }

                .topper-content-title{
                    font-size: 6em; /* 60px */
                }

                .topper-content-text{
                    font-size: 2.1428571429em; /* 21.428571429px */
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-5/topper.vue